import Rapor from "../../../../../components/categories/siakad/laporan_adab/rapor/Home"
export default function Home() {
  
  return (
    <Rapor />
  );
}
